import { PortfolioBookablePeriod, PortfolioProductOptions } from '@mews-commander/data-access';
import { ServicesFieldNames } from '../forms/schemas/configureProductFormSchema';

export const filterOptionsByPeriod = (period?: PortfolioBookablePeriod): PortfolioProductOptions[] =>
    period === PortfolioBookablePeriod.Month
        ? Object.values(PortfolioProductOptions)
        : Object.values(PortfolioProductOptions).filter((type) => type !== PortfolioProductOptions.ProRataCharging);

export const buildNestedFieldName = (field: string, parentKey?: string) =>
    parentKey ? `${ServicesFieldNames.Services}.${parentKey}.${field}` : field;
